import { render } from "./PayDetail.vue?vue&type=template&id=133ba4b2&scoped=true"
import script from "./PayDetail.vue?vue&type=script&lang=js"
export * from "./PayDetail.vue?vue&type=script&lang=js"

import "./PayDetail.vue?vue&type=style&index=0&id=133ba4b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-133ba4b2"

export default script